import React from "react";
import '../App.css';
import {useSpring, animated} from "react-spring";
import {easings} from "@react-spring/web";
import TutorialImage from "./TutorialImage";


function GuidaOverlay(props) {

    const style = useSpring({ to: { opacity: 1, marginTop: 0 }, from: { opacity: 0, marginTop: -100 }, config: {easing: easings.easeOutBack }})

    return(
        <>

                {props.isShown &&
                    <div className={"overlay"} onClick={() => {
                        props.toggleOverlay(false)
                    }
                    }>
                        <div className={"overlayBody center"}>

                            {
                                props.images.map(image => (
                                    <TutorialImage
                                        key = {image.id}
                                        image = {image}
                                    />
                                    )
                                )
                            }
                        </div>
                    </div>
                }
        </>
    );
}

export default GuidaOverlay